import Cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode';
import  { createContext, useState, useEffect, useContext } from "react";

export enum UserRoles {
  fleetweb = "fleetweb",
  firmware = "firmware",
  config = "config",
  support = "support",
  admin = "admin"
}

interface userDetails {
  first: string,
  last: string,
  name: string,
  email: string,
  user_id: string
};

export interface AuthData {
  user_details: userDetails
  roles: UserRoles[]
  token: string,
  expiration: number,
  refresh_token: string
};

interface AuthContext {
  user: AuthData | null,
  onLogin: ((newAuthData: AuthData) => void),
  onLogout: (() => void)
};

export const AuthDataContext = createContext<AuthContext>(
  {
    user: null,
    onLogin: (_: AuthData) => { },
    onLogout: () => { }
  }

);

function AuthDataProvider(props: any) {
  const [authData, setAuthData] = useState<AuthData | null>(null);
  const [authContext, setAuthContext] = useState<AuthContext>({
    user: null,
    onLogin: (_: AuthData) => { },
    onLogout: () => { }
  });

  /* The first time the component is rendered, it tries to
   * fetch the auth data from a source, like a cookie or
   * the localStorage.
   */
  useEffect(() => {
    const token = Cookies.get('__session') ? Cookies.get('__session') : null;
    if (token) {
      var decoded = jwtDecode<AuthData>(token);
      setAuthData(decoded);
    }
  }, []);

  useEffect(() => {
    setAuthContext({ user: authData, onLogin: onLogin, onLogout: onLogout })
  }, [authData]);


  const onLogout = () => {
    console.log("Setting Auth")
    setAuthData(null);
    console.log("Removing Cookie")
    Cookies.remove('__session', { sameSite: 'Strict' });
  }

  const onLogin = (newAuthData: AuthData) => setAuthData(newAuthData);

  return <AuthDataContext.Provider value={authContext} {...props} />;
};

export const useAuthDataContext = () => useContext(AuthDataContext);

export default AuthDataProvider;
